import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Row,
  Col
} from "reactstrap";

export default class AccountMenu extends Component {
  isActive(tab) {
    let className = null;
    if (tab === this.props.activeTab) {
      className = "active";
    }
    return className;
  }

  render() {
    const { tabs, onChangeTab } = this.props;

    return (
      <div className="account-menu">
        <Nav navbar>
          <Row>
            <Col className="column" xs="12" sm="auto">
              <NavItem className="account-item">
                <NavLink
                  className={this.isActive(tabs.myAccount)}
                  onClick={() => onChangeTab(tabs.myAccount)}
                  href="#"
                >
                  Minha Conta
                </NavLink>
              </NavItem>
            </Col>
            {this.props.isProfessional ? (
              <Col className="column" xs="12" sm="auto">
                <NavItem className="account-item">
                  <NavLink
                    className={this.isActive(tabs.professionalInfo)}
                    onClick={() => onChangeTab(tabs.professionalInfo)}
                    href="#"
                  >
                    Perfil Profissional
                  </NavLink>
                </NavItem>
              </Col>
            ) : null}

            {/* <Col className="column" xs="12" sm="auto">
              <NavItem className="account-item">
                <NavLink
                  className={this.isActive(tabs.financeOptions)}
                  onClick={() => onChangeTab(tabs.financeOptions)}
                  href="#"
                >
                  Opções Financeiras
                </NavLink>
              </NavItem>
            </Col> */}
            {/* <Col className="column custom" xs="12" sm="auto">
              <NavItem className="account-item">
                <Link className="nav-link" to="/credit/checkout">
                  Comprar créditos
                </Link>
              </NavItem>
            </Col> */}
          </Row>
        </Nav>
      </div>
    );
  }
}
